/** The running passes a queued "Run now" waits on, each linking to its run, so the
 * operator can see what it is behind and watch it. */
import { Link } from "react-router-dom";

import type { BlockingRun } from "../api/hooks/useAgentPortfolio";
import { runPath } from "../routes/learningAgentPaths";
import { formatRelative } from "../utils/formatRelative";

const sitesLabel = (projects: string[]): string => {
  if (projects.length === 0) return "every site";
  if (projects.length <= 2) return projects.join(", ");
  return `${projects.length} sites`;
};

export const BlockingRuns = ({ runs }: { runs: BlockingRun[] }) => (
  <>
    {runs.map((run, i) => (
      <span key={run.run_id}>
        {i > 0 && "; "}
        <Link to={runPath("scheduled", run.run_id)}>the run on {sitesLabel(run.projects)}</Link> (
        {run.started_by_email || "nightly schedule"}, started {formatRelative(run.created_at)})
      </span>
    ))}
  </>
);
